import {
  ADD_CHANGE_ERROR,
  CLEAR_ADD_CHANGE_ERROR,
} from '@xmatters/redux/actions/changes';

export const initialState = {
  addChangeError: null,
};

export default function changes(state = initialState, action) {
  switch (action.type) {
    case CLEAR_ADD_CHANGE_ERROR:
      return {
        ...state,
        addServiceError: null,
      };
    case ADD_CHANGE_ERROR:
      return {
        ...state,
        addServiceError: action.payload,
      };

    default:
      return state;
  }
}
